var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "q-pb-sm" },
    [
      _c(
        "q-field",
        { staticClass: "q-pa-md" },
        [
          _c("q-input", {
            attrs: {
              "inverted-light": "",
              color: "grey-12",
              rows: "7",
              type: "textarea",
              "float-label": "Notes",
              "max-height": 100,
              value: _vm.studentForm.STUDENT_NOTES
            },
            on: {
              keyup: function($event) {
                $event.stopPropagation()
                _vm.updateStudentForm({
                  field: "STUDENT_NOTES",
                  value: $event.target.value
                })
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }